module.exports = __webpack_public_path__ + "media/fangtan1.7d621052.mp4";